import api from './api';

export const getCompanyValues = async () => {
  const response = await api.get('/company-values/');
  return response.data;
};

export const createCompanyValue = async (valueData) => {
  const response = await api.post('/company-values/', valueData);
  return response.data;
};

export const getCompanyValuesStats = async () => {
  const response = await api.get('/company-values/stats');
  return response.data;
};

export const updateCompanyValue = async (valueId, data) => {
  const response = await api.put(`/company-values/${valueId}`, data);
  return response.data;
};

export const deleteCompanyValue = async (valueId) => {
  const response = await api.delete(`/company-values/${valueId}`);
  return response.data;
};
